/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Inject, OnInit, signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusDraft } from '../../common/community/feed/status-form/community-status-form.component';

// "Mention" on someone's profile: the community status form, starting with their @username.
@Component({
  selector: 'ut-community-profile-mention-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  template: `
    <div class="profile-dialog profile-dialog--wide">
      <ngf-dialog-title class="profile-dialog__title" mat-dialog-title>Mention {{ data.user.name }}</ngf-dialog-title>
      <mat-dialog-content class="profile-dialog__body">
        <p class="profile-dialog__text">Post a status update that tags them.</p>
        <ut-community-status-form
          class="profile-dialog__form"
          [content]="'@' + data.user.slug + ' '"
          [cancellable]="true"
          [busy]="posting()"
          [authorUserType]="authorUserType()"
          (submitted)="post($event)"
          (cancelled)="dialogRef.close()"></ut-community-status-form>
      </mat-dialog-content>
    </div>
  `,
  styleUrls: ['../shared/community-profile-dialog.scss'],
})
export class CommunityProfileMentionDialogComponent implements OnInit {
  posting = signal(false);
  // The mention is posted as the current user, so the limit is the current user's.
  authorUserType = signal<string | null>(null);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: any },
    @Inject('StatusService') private StatusService: any,
    @Inject('AlertService') private AlertService: any,
    @Inject('ServerMessages') private ServerMessages: any,
    @Inject('UserService') private UserService: any,
    public dialogRef: MatDialogRef<CommunityProfileMentionDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.UserService.me().then((res: any) => this.authorUserType.set(res?.data?.user_type ?? null));
  }

  post(draft: StatusDraft): void {
    this.posting.set(true);
    this.StatusService.create(draft.content, draft.attached_url).then(() => {
      this.AlertService.add('Status successfully posted');
      this.dialogRef.close();
    }, (response) => {
      this.posting.set(false);
      this.AlertService.addDanger(this.ServerMessages.prettyMessage(response));
    });
  }
}
